import React from 'react';
import { Grid, TextField, Autocomplete, Box, Typography, Divider } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import { IMAGE_DIMENSIONS, GEMINI_ASPECT_RATIOS, GEMINI_IMAGE_SIZES } from '../constants/aiModels';

function ImageFieldsSection({ 
  provider, 
  providerAi,
  onAutocompleteChange,
  imageDimension,
  aspectRatio,
  imageSize,
  errors 
}) {
  if (provider === 'openai') {
    return (
      <>
        <Grid item xs={12}>
          <Divider sx={{ my: 2 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <ImageIcon color="primary" />
            <Typography variant="subtitle1" color="primary" fontWeight={600}>
              Configuración de Imagen
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box 
            sx={{ 
              p: 2, 
              borderRadius: 2, 
              border: '1px solid',
              borderColor: 'divider',
              backgroundColor: 'rgba(0, 74, 173, 0.02)'
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={IMAGE_DIMENSIONS.map(d => d.resolution)}
                  value={imageDimension || ""}
                  onChange={(e, newValue) => onAutocompleteChange({ resolution: newValue }, 'extra_parameters')}
                  disabled={!providerAi}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Dimensión de la imagen"
                      required
                      error={!!errors.imageDimension}
                      helperText={errors.imageDimension || "Ej: 1024x1024, 1536x1024"}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </>
    );
  }

  if (provider === 'gemini') {
    return (
      <>
        <Grid item xs={12}>
          <Divider sx={{ my: 2 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <ImageIcon color="primary" />
            <Typography variant="subtitle1" color="primary" fontWeight={600}>
              Configuración de Imagen
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box 
            sx={{ 
              p: 2, 
              borderRadius: 2, 
              border: '1px solid',
              borderColor: 'divider',
              backgroundColor: 'rgba(0, 74, 173, 0.02)'
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Autocomplete
                  freeSolo
                  options={GEMINI_ASPECT_RATIOS}
                  value={aspectRatio || ""}
                  onChange={(e, newValue) => onAutocompleteChange({ aspect_ratio: newValue }, 'extra_parameters')}
                  disabled={!providerAi}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Aspect Ratio"
                      required
                      error={!!errors.aspectRatio}
                      helperText={errors.aspectRatio || "Ej: 1:1, 16:9, 9:16, 21:9"}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <Autocomplete
                  freeSolo
                  options={GEMINI_IMAGE_SIZES}
                  value={imageSize || ""}
                  onChange={(e, newValue) => onAutocompleteChange({ image_size: newValue }, 'extra_parameters')}
                  disabled={!providerAi}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Image Size"
                      required
                      error={!!errors.imageSize}
                      helperText={errors.imageSize || "Ej: 1k, 2k, 4k"}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </>
    );
  }

  return null;
}

export default ImageFieldsSection;
